import MySubscriptions from './MySubscriptions';

export default MySubscriptions;
